module.exports = __webpack_public_path__ + "nebular.bfbfd2c47a08b07c3a4f.woff";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/nebular-icons/fonts/nebular.woff?jaecku
// module id = ../../../../nebular-icons/fonts/nebular.woff?jaecku
// module chunks = styles